<script setup lang="ts">
import { onMounted, onUnmounted, ref, useTemplateRef } from 'vue';

const props = defineProps<{
  hover?: boolean;
}>();

const container = useTemplateRef('dropdown-container');

const enteredFromHover = ref(false);

onMounted(async () => {
  container.value!.onmouseenter = onenter;
  container.value!.onmouseleave = onleave;
  document.body.addEventListener('mousedown', outsideClickListener);
});

onUnmounted(() => {
  document.body.removeEventListener('mousedown', outsideClickListener);
});

function outsideClickListener(e: MouseEvent) {
  const inDropdown = e.composedPath().some((val) => val === container.value);
  if (inDropdown) {
    // in the dropdown, we don't want to close here
    return;
  } else {
    close();
  }
}

const visibility = ref(false);

function onleave() {
  if (enteredFromHover.value) {
    close();
  }
}

function onenter() {
  if (props.hover) {
    enteredFromHover.value = true;
    open();
  }
}

function clicked() {
  if (visibility.value) {
    close();
  } else {
    enteredFromHover.value = false;
    open();
  }
}

function open() {
  visibility.value = true;
}

function close() {
  enteredFromHover.value = false;
  visibility.value = false;
}
</script>

<template>
  <div class="dropdown" ref="dropdown-container">
    <div class="dropdown-header" @click="clicked">
      <slot name="header"></slot>
    </div>
    <div class="dropdown-items" v-show="visibility">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.dropdown-items {
  display: flex;
}
</style>
